import { render, staticRenderFns } from "./JobworkReceiptReturnForm.vue?vue&type=template&id=36a7699a&scoped=true"
import script from "./JobworkReceiptReturnForm.vue?vue&type=script&lang=js"
export * from "./JobworkReceiptReturnForm.vue?vue&type=script&lang=js"
import style0 from "./JobworkReceiptReturnForm.vue?vue&type=style&index=0&id=36a7699a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7699a",
  null
  
)

export default component.exports